export const manualActivityStyles = {
  page: {
    paddingTop: 12,
  } as const,
  hero: {
    borderRadius: 24,
    background: '#ffffff',
    padding: '16px 16px 14px',
    border: '1px solid rgba(232, 236, 244, 0.96)',
    boxShadow: '0 12px 28px rgba(31, 35, 41, 0.08)',
  } as const,
  eyebrow: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 7,
    fontSize: 13,
    lineHeight: 1.2,
    fontWeight: 800,
    color: '#6872f5',
  } as const,
  eyebrowBar: {
    width: 4,
    height: 18,
    borderRadius: 999,
    background: '#6872f5',
  } as const,
  title: {
    marginTop: 10,
    fontSize: 24,
    lineHeight: 1.15,
    fontWeight: 800,
    color: '#1f2430',
  } as const,
  subtitle: {
    marginTop: 8,
    fontSize: 13,
    lineHeight: 1.55,
    color: '#858da1',
    fontWeight: 600,
  } as const,
  statGrid: {
    marginTop: 14,
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: 8,
  } as const,
  statBox: {
    borderRadius: 16,
    background: '#f7f8fc',
    padding: '10px 8px',
    minHeight: 74,
  } as const,
  statLabel: {
    fontSize: 11,
    lineHeight: 1.3,
    color: '#8b92a4',
    fontWeight: 700,
  } as const,
  statValue: {
    marginTop: 6,
    fontSize: 22,
    lineHeight: 1,
    color: '#1f2430',
    fontWeight: 800,
  } as const,
  progressTrack: {
    marginTop: 14,
    height: 8,
    borderRadius: 999,
    background: '#edf0f8',
    overflow: 'hidden',
  } as const,
  progressFill: {
    height: '100%',
    borderRadius: 999,
    background: 'linear-gradient(90deg, #6872f5 0%, #37c98f 100%)',
  } as const,
  taskCard: {
    borderRadius: 22,
    background: '#ffffff',
    padding: '16px 14px',
    border: '1px solid rgba(232, 236, 244, 0.96)',
    boxShadow: '0 10px 22px rgba(82, 88, 110, 0.07)',
  } as const,
  redemptionCard: {
    borderRadius: 22,
    background: '#ffffff',
    padding: '16px 14px',
    border: '1px solid rgba(232, 236, 244, 0.96)',
    boxShadow: '0 10px 22px rgba(82, 88, 110, 0.07)',
  } as const,
  redemptionId: {
    marginTop: 5,
    color: '#858da1',
    fontSize: 11,
    lineHeight: 1.35,
    fontWeight: 700,
    wordBreak: 'break-all',
  } as const,
  redemptionStats: {
    marginTop: 14,
    display: 'grid',
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
    gap: 8,
  } as const,
  scanProgressBox: {
    marginTop: 14,
    borderRadius: 16,
    background: '#f7f8fc',
    border: '1px solid rgba(232, 236, 244, 0.96)',
    padding: '12px',
  } as const,
  scanProgressHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
    color: '#1f2430',
    fontSize: 13,
    lineHeight: 1.35,
    fontWeight: 900,
  } as const,
  scanProgressTrack: {
    marginTop: 10,
    height: 8,
    borderRadius: 999,
    background: '#e7ebf5',
    overflow: 'hidden',
  } as const,
  scanProgressFill: {
    height: '100%',
    borderRadius: 999,
    background: 'linear-gradient(90deg, #6872f5 0%, #37c98f 100%)',
    transition: 'width 240ms ease',
  } as const,
  scanProgressMeta: {
    marginTop: 8,
    color: '#858da1',
    fontSize: 12,
    lineHeight: 1.35,
    fontWeight: 700,
  } as const,
  redemptionAuthToolbar: {
    marginTop: 14,
    display: 'grid',
    gap: 8,
  } as const,
  authToolbarHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
  } as const,
  refreshCredentialButton: {
    minWidth: 64,
    height: 30,
    borderRadius: 999,
    border: '1px solid #dfe3f1',
    background: '#ffffff',
    color: '#5f68f2',
    fontSize: 12,
    lineHeight: 1,
    fontWeight: 900,
    padding: '0 10px',
  } as const,
  refreshCredentialButtonDisabled: {
    opacity: 0.56,
  } as const,
  qrPlaceholder: {
    marginTop: 14,
    minHeight: 112,
    borderRadius: 16,
    background: '#f7f8fc',
    border: '1px dashed #ccd3e4',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '14px',
    textAlign: 'center',
  } as const,
  qrImage: {
    width: 188,
    height: 188,
    borderRadius: 12,
    background: '#ffffff',
    padding: 8,
    border: '1px solid #e6eaf3',
  } as const,
  credentialLoading: {
    minHeight: 88,
    display: 'grid',
    alignItems: 'center',
    justifyItems: 'center',
    alignContent: 'center',
    gap: 10,
  } as const,
  credentialFailure: {
    minHeight: 88,
    display: 'grid',
    alignItems: 'center',
    justifyItems: 'center',
    alignContent: 'center',
    gap: 8,
  } as const,
  credentialFailureTitle: {
    color: '#c2410c',
    fontSize: 14,
    lineHeight: 1.45,
    fontWeight: 900,
  } as const,
  placeholderHint: {
    color: '#687083',
    fontSize: 13,
    lineHeight: 1.55,
    fontWeight: 700,
  } as const,
  pairingCode: {
    color: '#1f2430',
    fontSize: 24,
    lineHeight: 1.2,
    fontWeight: 900,
    letterSpacing: 0,
  } as const,
  redemptionForm: {
    display: 'grid',
    gap: 10,
    textAlign: 'left',
  } as const,
  inputShell: {
    minHeight: 46,
    borderRadius: 14,
    background: '#f7f8fc',
    border: '1px solid rgba(223, 227, 241, 0.95)',
    display: 'flex',
    alignItems: 'center',
    padding: '0 12px',
  } as const,
  authSwitch: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: 8,
  } as const,
  authSwitchButton: {
    height: 42,
    borderRadius: 14,
    border: '1px solid #dfe3f1',
    background: '#ffffff',
    color: '#566071',
    fontSize: 13,
    fontWeight: 800,
  } as const,
  authSwitchButtonActive: {
    borderColor: '#6872f5',
    background: '#eef1ff',
    color: '#5f68f2',
  } as const,
  authSwitchButtonDisabled: {
    opacity: 0.56,
  } as const,
  taskHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: 10,
  } as const,
  taskTitle: {
    fontSize: 18,
    lineHeight: 1.25,
    color: '#1f2430',
    fontWeight: 800,
  } as const,
  pill: {
    flexShrink: 0,
    borderRadius: 999,
    background: '#eef1ff',
    color: '#5f68f2',
    padding: '6px 10px',
    fontSize: 11,
    lineHeight: 1.2,
    fontWeight: 800,
  } as const,
  field: {
    marginTop: 14,
    borderRadius: 16,
    background: '#f7f8fc',
    border: '1px solid rgba(232, 236, 244, 0.96)',
    padding: '12px',
  } as const,
  fieldLabel: {
    fontSize: 12,
    lineHeight: 1.3,
    color: '#858da1',
    fontWeight: 800,
  } as const,
  phoneValue: {
    marginTop: 6,
    fontSize: 20,
    lineHeight: 1.2,
    color: '#1f2430',
    fontWeight: 800,
    wordBreak: 'break-word',
  } as const,
  messageValue: {
    marginTop: 8,
    fontSize: 15,
    lineHeight: 1.6,
    color: '#2a3140',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  } as const,
  actions: {
    marginTop: 14,
    display: 'grid',
    gap: 10,
  } as const,
  primaryButton: {
    '--background-color': '#6872f5',
    '--border-radius': '16px',
    height: 48,
    fontWeight: 800,
  } as const,
  secondaryButton: {
    '--border-color': '#dfe3f1',
    '--text-color': '#566071',
    '--border-radius': '16px',
    height: 46,
    fontWeight: 800,
  } as const,
  notice: {
    borderRadius: 18,
    background: '#fff8e8',
    color: '#7c5a10',
    padding: '13px 14px',
    fontSize: 13,
    lineHeight: 1.55,
    fontWeight: 700,
    border: '1px solid #ffefc7',
  } as const,
  emptyCard: {
    borderRadius: 22,
    background: '#ffffff',
    padding: '28px 18px',
    textAlign: 'center',
    border: '1px solid rgba(232, 236, 244, 0.96)',
    boxShadow: '0 10px 22px rgba(82, 88, 110, 0.07)',
  } as const,
};
